var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PriceHistoryWithCeneo.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-0c284173!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PriceHistoryWithCeneo.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Product/PriceHistoryWithCeneo.vue
// module id = 200
// module chunks = 2